import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import React from "react";
import styled from "styled-components";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import RichText from "@/components/editor/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { Hump } from "@/components/editor/themes/hazel/shared/vector-graphics";
import { ColorLabels } from "@/components/editor/utils/colors";

const StyledPaddingWrapper = styled(BlockPaddingWrapper)`
  padding-bottom: 0;
`;

const StyledGrid = withViewportStyle("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(24)};

  ${(props) =>
    props.$viewport.tablet`
      grid-template-columns: 1fr;
      grid-gap: ${rem(8)};

      .button-primitive {
        width: 100%;
        margin-top: ${rem(24)};
      }
  `}
`;

const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledContent = styled.div`
  padding-bottom: ${rem(100)};
`;

const StyledHumps = withViewportStyle("div")`
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1;
  align-items: flex-end;

  ${(props) => props.$viewport.tablet`
      display: none;
  `}
  
  ${Hump} {
    position: relative;

    fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_3]};
    
    &:nth-child(1) {
      left: 0;
      z-index: var(--z-index-medium);
      width: ${rem(200)};
      height: ${rem(200)};
    }

    &:nth-child(2) {
      left: -5px;
      opacity: 0.6;
      z-index: var(--z-index-low);
      width: ${rem(160)};
      height: ${rem(150)};
    }

    &:nth-child(3) {
      width: ${rem(110)};
      height: ${rem(100)};
      left: -15px;
      opacity: 0.3;
      z-index: var(--z-index-lowest);
    }
  }
`;

export default function AboutDetails() {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <StyledPaddingWrapper>
        <BlockMaxWidthWrapper>
          <StyledGrid>
            <StyledTitle>
              <Element
                id="subtitle"
                is={RichText}
                text={`<h3>Join our first digital conference.</h3>`}
              />
              <StyledHumps>
                <Hump />
                <Hump />
                <Hump />
              </StyledHumps>
            </StyledTitle>
            <StyledContent>
              <Element
                id="description"
                is={RichText}
                text={`
                <p class='paragraph'>We’re here to help shape the future in a sustainable way. Our team is made of experts that help companies invest in renewable energy, and we support many initiatives to make the food industry more sustainable for our planet.</p>
                <ul>
                  <li>Learn what the best minds in the industry are focusing on </li>
                  <li>Skip the cliches and dive deep into the real issues around sustainability and renewable energy</li>
                  <li>Get an insider view on how the leading companies in the industry see the future; what they want the world to look like 50 years from now, and how they’re planning to get there</li>
                  <li>Connect with other top professionals and find new opportunities to join forces and drive positive change</li>
                </ul>
              `}
              />
            </StyledContent>
          </StyledGrid>
        </BlockMaxWidthWrapper>
      </StyledPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

AboutDetails.craft = {
  custom: {
    displayName: "About Details",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
